<ng-template #preHeader>
    SIGN IN <shared-disabled-text>/ SIGN UP</shared-disabled-text>
</ng-template>
<shared-auth-header [preHeader]="preHeader" [description]="description">
    Forgot your password?
</shared-auth-header>
<ng-template #description>
    Don’t you just hate that! Don’t worry we have you covered.
    Enter your email address and we will send steps to reset.
</ng-template>

<shared-form-for-forgot-password [modal]="true"></shared-form-for-forgot-password>